import Cookies from 'js-cookie'

const mutations = {
  SET_PERSON_ROLE_TYPE (state, data) {
    Cookies.set('personRoleType', data)
    state.personRoleType = data;
  }
}

export default mutations